import moment from 'moment';
import * as _ from 'underscore';
import { TYPES } from '../state/reducer/calendar/programTypes';

const angular = {
    copy: () => {
        // console.error('ARYN FIX THIS COPY');
    }
};

export const dateCalendar = {
    currentTargetDate: new Date(),
    currentMonthTitle: '',
    totalDays: 0,
    dayNumToName: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
    months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    days: [],
    weeks: [],
    today: new Date(),
    todaysItem: { isSet: false },
    programs: [],
    unpublishedItems: [],

    init(targetDate, numWeeks) {
        console.log('DATE CALENDAR');
        if (moment.isMoment(targetDate)) {
            targetDate = targetDate.toDate();
        }
        this.days = [];
        this.weeks = [];
        if (typeof numWeeks === 'undefined') {
            numWeeks = 6;
        }
        const days = this.days;
        const weeks = this.weeks;
        let returnItems = false;

        this.currentTargetDate = targetDate;
        this.currentMonthTitle = `${
            this.months[targetDate.getMonth()]
        } ${targetDate.getFullYear()}`;
        const targetDateMoment = moment(targetDate);
        const startOfCurrentMonth = new Date(
            targetDate.getFullYear(),
            targetDate.getMonth(),
            1
        );
        const currentMonthStartDayOfWeek =
            startOfCurrentMonth.getDay() === 0
                ? 7
                : startOfCurrentMonth.getDay();
        const currentMonthDays = new Date(
            targetDate.getFullYear(),
            targetDate.getMonth() + 1,
            0
        ).getDate();
        const endOfCurrentMonth = new Date(
            targetDate.getFullYear(),
            targetDate.getMonth(),
            currentMonthDays
        );
        const currentMonthEndDayOfWeek = endOfCurrentMonth.getDay();
        const previousMonth = this.getPreviousMonthAsDate(targetDate);
        const previousMonthDays = previousMonth.getDate();
        const nextMonth = this.getNextMonthAsDate(targetDate);

        this.totalDays =
            currentMonthDays +
            currentMonthStartDayOfWeek +
            (6 - currentMonthEndDayOfWeek);
        const currentMonthCalendarEnd =
            currentMonthStartDayOfWeek + currentMonthDays - 1;

        for (let i = 0; i < this.totalDays; i++) {
            let thisDaysWeek = 0;
            if (i > 7) {
                thisDaysWeek = Math.floor(i / 7);
            } else if (i === 7) {
                thisDaysWeek = 1;
            }

            // Monthly calendar
            if (numWeeks > 1) {
                // Still last month?
                if (i < currentMonthStartDayOfWeek) {
                    const dayOfLastMonth =
                        previousMonthDays +
                        (i - (currentMonthStartDayOfWeek - 1));
                    const lastMonthDate = new Date(
                        previousMonth.getFullYear(),
                        previousMonth.getMonth(),
                        dayOfLastMonth
                    );

                    days[i] = {
                        // eslint-disable-next-line
                        key: `${lastMonthDate.getFullYear()}_${lastMonthDate.getMonth() +
                            1}_${lastMonthDate.getDate()}`,
                        index: i - thisDaysWeek * 7,
                        weekIndex: thisDaysWeek,
                        date: lastMonthDate,
                        year: lastMonthDate.getFullYear(),
                        month: lastMonthDate.getMonth() + 1,
                        day: lastMonthDate.getDate(),
                        title: lastMonthDate.getDate(),
                        contextTitle: `${this.months[
                            lastMonthDate.getMonth()
                        ].substring(0, 3)} ${lastMonthDate.getDate()}`,
                        selected: false,
                        // items: [],
                        currentMonth: false
                    };
                }
                // Next Month?
                else if (i > currentMonthCalendarEnd) {
                    const dayOfNextMonth =
                        i - currentMonthCalendarEnd <= 0
                            ? 1
                            : i - currentMonthCalendarEnd;
                    const nextMonthDate = new Date(
                        nextMonth.getFullYear(),
                        nextMonth.getMonth(),
                        dayOfNextMonth
                    );

                    var title = nextMonthDate.getDate();
                    var contextTitle = `${this.months[
                        nextMonthDate.getMonth()
                    ].substring(0, 3)} ${nextMonthDate.getDate()}`;
                    if (nextMonthDate.getDate() === 1) {
                        title = contextTitle;
                    }
                    days[i] = {
                        // eslint-disable-next-line
                        key: `${nextMonthDate.getFullYear()}_${nextMonthDate.getMonth() +
                            1}_${nextMonthDate.getDate()}`,
                        index: i - thisDaysWeek * 7,
                        weekIndex: thisDaysWeek,
                        date: nextMonthDate,
                        year: nextMonthDate.getFullYear(),
                        month: nextMonthDate.getMonth() + 1,
                        day: nextMonthDate.getDate(),
                        title,
                        contextTitle,
                        selected: false,
                        // items: [],
                        currentMonth: false
                    };
                }
                // Current Month
                else {
                    const dayOfThisMonth = i - currentMonthStartDayOfWeek + 1;
                    let selected = false;
                    if (dayOfThisMonth === this.today.getDate()) {
                        selected = true;
                    }

                    let thisMonthDate = new Date(
                        targetDate.getFullYear(),
                        targetDate.getMonth(),
                        dayOfThisMonth
                    );
                    let title = thisMonthDate.getDate();
                    let contextTitle = `${this.months[
                        thisMonthDate.getMonth()
                    ].substring(0, 3)} ${thisMonthDate.getDate()}`;
                    if (thisMonthDate.getDate() === 1) {
                        title = contextTitle;
                    }

                    days[i] = {
                        // eslint-disable-next-line
                        key: `${thisMonthDate.getFullYear()}_${thisMonthDate.getMonth() +
                            1}_${thisMonthDate.getDate()}`,
                        index: i - thisDaysWeek * 7,
                        weekIndex: thisDaysWeek,
                        date: thisMonthDate,
                        year: thisMonthDate.getFullYear(),
                        month: thisMonthDate.getMonth() + 1,
                        day: thisMonthDate.getDate(),
                        title,
                        contextTitle,
                        selected,
                        currentMonth: true
                    };
                }
            }
            // Weekly calendar
            else {
                const _targetDate = targetDateMoment.toDate();
                let selected = false;
                if (_targetDate.getDay() === this.today.getDate()) {
                    selected = true;
                }

                let thisMonthDate = angular
                    .copy(targetDateMoment)
                    .startOf('month')
                    .toDate();
                let title = thisMonthDate.getDate();
                let contextTitle = targetDateMoment.format('MMM DD');
                if (thisMonthDate.getDate() === 1) {
                    title = contextTitle;
                }
                days[i] = {
                    // eslint-disable-next-line
                    key: `${_targetDate.getFullYear()}_${_targetDate.getMonth() +
                        1}_${_targetDate.getDate()}`,
                    index: i - thisDaysWeek * 7,
                    weekIndex: thisDaysWeek,
                    date: _targetDate,
                    year: _targetDate.getFullYear(),
                    month: _targetDate.getMonth() + 1,
                    day: _targetDate.getDate(),
                    title,
                    contextTitle,
                    selected
                };
                targetDateMoment.add(1, 'day');
                returnItems = true;
            }
        }

        let everySeven = 1;
        let weekIndex = 0;
        let week = { index: weekIndex, days: [] };
        for (let i = 0; i < this.totalDays; i++) {
            week.days.push(days[i]);
            if (everySeven === 7) {
                everySeven = 1;
                weeks.push(week);
                weekIndex++;
                week = { index: weekIndex, days: [] };
                continue;
            }
            everySeven++;
        }
        if (returnItems) {
            return weeks;
        }
    },

    getNextMonthAsDate(date) {
        if (date.getMonth() === 11) {
            return new Date(date.getFullYear() + 1, 1, 0);
        }
        return new Date(date.getFullYear(), date.getMonth() + 2, 0);
    },

    getPreviousMonthAsDate(date) {
        if (date.getMonth() < 1) {
            return new Date(date.getFullYear() - 1, 12, 0);
        }
        return new Date(date.getFullYear(), date.getMonth(), 0);
    },

    addNewProgramWorkouts(
        newProgramWorkouts,
        subscriptionTitle,
        subCount,
        subscriptionType
    ) {
        let programSubscription = false;
        let teamSubscription = false;
        if (
            typeof subCount !== 'undefined' &&
            typeof subscriptionType !== 'undefined'
        ) {
            programSubscription = subscriptionType === 'program';
            teamSubscription = subscriptionType === 'team';
        }
        const undoIndexes = [];
        for (var i = 0; i < this.weeks.length; i++) {
            const week = this.weeks[i];
            for (var j = 0; j < week.days.length; j++) {
                var day = week.days[j];
                const dayList = _.filter(
                    newProgramWorkouts,
                    item =>
                        item.year === day.year &&
                        item.month === day.month &&
                        item.day === day.day
                );
                _.each(dayList, item => {
                    day.items.push({
                        type: 'workout',
                        data: item,
                        subscription: programSubscription,
                        teamSubscription,
                        subscriptionTitle,
                        subCount
                    });
                    // Add this index to the undo array so it is easy
                    // to find and remove each of these
                    undoIndexes.push({
                        weekIndex: i,
                        dayIndex: j,
                        itemsIndex: day.items.length - 1,
                        workoutId: item.id
                    });
                });
            }
        }
        return undoIndexes;
    },

    removeTeamSubscriptionItems(subCount) {
        for (let weekIndex = 0; weekIndex < this.weeks.length; weekIndex++) {
            for (
                let dayIndex = 0;
                dayIndex < this.weeks[weekIndex].days.length;
                dayIndex++
            ) {
                for (
                    let itemIndex = 0;
                    itemIndex <
                    this.weeks[weekIndex].days[dayIndex].items.length;
                    itemIndex++
                ) {
                    if (
                        this.weeks[weekIndex].days[dayIndex].items[itemIndex]
                            .teamSubscription &&
                        this.weeks[weekIndex].days[dayIndex].items[itemIndex]
                            .subCount === subCount
                    ) {
                        this.weeks[weekIndex].days[dayIndex].items.splice(
                            itemIndex,
                            1
                        );
                        itemIndex--;
                    }
                }
            }
        }
    },

    removeProgramSubscriptionItems(subCount) {
        for (let weekIndex = 0; weekIndex < this.weeks.length; weekIndex++) {
            for (
                let dayIndex = 0;
                dayIndex < this.weeks[weekIndex].days.length;
                dayIndex++
            ) {
                for (
                    let itemIndex = 0;
                    itemIndex <
                    this.weeks[weekIndex].days[dayIndex].items.length;
                    itemIndex++
                ) {
                    if (
                        this.weeks[weekIndex].days[dayIndex].items[itemIndex]
                            .subscription &&
                        this.weeks[weekIndex].days[dayIndex].items[itemIndex]
                            .subCount === subCount
                    ) {
                        this.weeks[weekIndex].days[dayIndex].items.splice(
                            itemIndex,
                            1
                        );
                        itemIndex--;
                    }
                }
            }
        }
    },

    removeItem(weekIndex, dayIndex, itemId) {
        for (
            let i = 0;
            i < this.weeks[weekIndex].days[dayIndex].items.length;
            i++
        ) {
            if (
                this.weeks[weekIndex].days[dayIndex].items[i].data.id === itemId
            ) {
                this.weeks[weekIndex].days[dayIndex].items.splice(i, 1);
                break;
            }
        }
    },

    replaceItem(
        weekIndex,
        dayIndex,
        replaceItemId,
        newItem,
        subscribedProgram,
        subCount
    ) {
        let subscriptionTitle = '';
        let isSubscription = false;
        if (
            typeof subscribedProgram !== 'undefined' &&
            typeof subCount !== 'undefined'
        ) {
            subscriptionTitle = subscribedProgram.title;
            isSubscription = true;
        }
        for (
            let i = 0;
            i < this.weeks[weekIndex].days[dayIndex].items.length;
            i++
        ) {
            if (
                this.weeks[weekIndex].days[dayIndex].items[i].data.id ===
                replaceItemId
            ) {
                newItem = this.weeks[weekIndex].days[dayIndex].items[i] = {
                    type: 'workout',
                    data: newItem,
                    subscription: isSubscription,
                    subscriptionTitle,
                    subCount
                };
                this.weeks[weekIndex].days[dayIndex].items[i] = newItem;
                return newItem;
            }
        }
    },

    getTodaysFirstItem() {
        if (this.todaysItem !== null) {
            return this.todaysItem;
        }
    },

    updateUnpublishedItems() {
        this.unpublishedItems = [];

        for (let weekIndex = 0; weekIndex < this.weeks.length; weekIndex++) {
            const week = this.weeks[weekIndex];
            for (let dayIndex = 0; dayIndex < week.days.length; dayIndex++) {
                const day = week.days[dayIndex];
                for (
                    let itemIndex = 0;
                    itemIndex < day.items.length;
                    itemIndex++
                ) {
                    if (
                        day.items[itemIndex].data.published !== 1 ||
                        day.items[itemIndex].data.published !== '1'
                    ) {
                        this.unpublishedItems.push(day.items[itemIndex]);
                    }
                }
            }
        }

        return this.unpublishedItems.length;
    },

    setAllToPublished() {
        for (let weekIndex = 0; weekIndex < this.weeks.length; weekIndex++) {
            const week = this.weeks[weekIndex];
            for (let dayIndex = 0; dayIndex < week.days.length; dayIndex++) {
                const day = week.days[dayIndex];
                for (
                    let itemIndex = 0;
                    itemIndex < day.items.length;
                    itemIndex++
                ) {
                    day.items[itemIndex].data.published = 1;
                }
            }
        }
        this.updateUnpublishedItems();
    }
};

export const timelineCalendar = {
    totalDays: 0,
    weeks: [],
    cachedCalendars: [],

    getMonthCachedCalendar(id, date) {
        this.data = this.cachedCalendars[id] && this.cachedCalendars[id][date];
    },

    setMonthCachedCalendar(id, date) {
        this.cachedCalendars[id] = this.cachedCalendars[id] || {};
        this.cachedCalendars[id][date] = angular.copy(this.data);
    },

    updateCachedCalendarDay(id, date, data) {
        this.cachedCalendars[id] = this.cachedCalendars[id] || {};
        const cachedCalendar = this.cachedCalendars[id][date];
        // update cached calendar
        if (cachedCalendar && data) {
            let sameDayIndex = null;
            if (data.month) {
                sameDayIndex = _.findIndex(cachedCalendar.days, {
                    day: data.day,
                    month: data.month
                });
            } else {
                sameDayIndex = _.findIndex(cachedCalendar.days, {
                    timelineDay: data.timelineDay
                });
            }
            const _day = cachedCalendar.days[sameDayIndex];
            _day.index = data.index;
            _day.items = data.items;
            this.cachedCalendars[id][date].weeks[data.weekIndex].days[
                data.index
            ] = _day;
        }
    },

    clearMonthCachedCalendars() {
        this.cachedCalendars = {};
    },

    isCached(id, date) {
        this.cachedCalendars[id] = this.cachedCalendars[id] || {};
        if (this.cachedCalendars[id][date]) {
            return true;
        }
        return false;
    },

    init(programLength) {
        this.totalDays = programLength;
        this.weeks = [];
        this.days = [];
        let week = 0;
        let weekData = {
            index: week,
            title: `Week ${week + 1}`,
            days: []
        };
        const days = [];
        for (let i = 0; i < this.totalDays; i++) {
            let thisDaysWeek = 0;
            thisDaysWeek = Math.floor(i / 7);
            if (thisDaysWeek > week) {
                this.weeks.push(weekData);
                week = thisDaysWeek;
                weekData = {
                    index: week,
                    title: `Week ${week + 1}`,
                    days: []
                };
            }

            let dayIndex = 0;
            if (thisDaysWeek === 0) {
                dayIndex = i;
            } else {
                dayIndex = i % (thisDaysWeek * 7);
            }

            const dayData = {
                weekIndex: thisDaysWeek,
                index: dayIndex,
                numItems: 0,
                title: dayIndex + 1,
                contextTitle: `Week ${thisDaysWeek + 1}, Day ${dayIndex + 1}`,
                timelineDay: thisDaysWeek * 7 + (dayIndex + 1)
            };

            weekData.days.push(dayData);
            days.push(dayData);
        }
        this.days = days;
        this.weeks.push(weekData);
    },

    getDayDataByTimelineDay(timelineDay) {
        var weekIndex,
            dayIndex = -1;
        if (timelineDay <= 7) {
            weekIndex = 0;
            dayIndex = timelineDay - 1;
        } else {
            weekIndex = this.getWeekIndexFromTimelineDay(timelineDay);
            dayIndex = this.getDayIndexFromTimelineDay(timelineDay);
        }
        return this.weeks[weekIndex].days[dayIndex];
    },

    getTimelineDay(weekIndex, dayIndex) {
        return weekIndex * 7 + dayIndex + 1;
    },

    getWeekIndexFromTimelineDay(timelineDay) {
        if (timelineDay % 7 === 0) {
            return Math.floor(timelineDay / 7) - 1;
        }
        return Math.floor(timelineDay / 7);
    },
    getDayIndexFromTimelineDay(timelineDay) {
        // Day Index is zero based and based off a week
        // EXAMPLE: timelineDay of 28 is the 7th day of the
        // 4 week so return it zero based i.e. 6
        if (timelineDay % 7 === 0) {
            return 6;
        } else if (timelineDay > 7) {
            return (timelineDay % 7) - 1;
        }
        return timelineDay - 1;
    }
};

export const programCalendar = {
    // TYPES: 1-Calendar, 2-Finite
    type: 0,
    programs: [],
    data: {},
    length: 0,

    init(type, targetDate, numWeeks, programLength) {
        this.type = parseInt(type);
        // For purposes of date calendars, team, athlete
        // and calendar-based programs are the same
        if (
            this.type === TYPES.TEAM ||
            this.type === TYPES.ATHLETE_CALENDAR ||
            this.type === TYPES.COACH_ATHLETE_CALENDAR ||
            this.type === TYPES.INVITED_ATHLETE_CALENDAR
        ) {
            this.type = TYPES.CALENDAR;
        }

        switch (this.type) {
            case 1:
                if (typeof numWeeks === 'undefined') {
                    numWeeks = 5;
                }
                this.length = numWeeks * 7;
                // Create Date Based Calendar
                var dateCal = dateCalendar;
                dateCal.init(targetDate, numWeeks);
                this.data = dateCal;
                // }
                break;
            case 2:
                // Create Fixed Calendar
                this.length = programLength;
                var timelineCal = timelineCalendar;
                timelineCal.init(programLength);
                this.data = timelineCal;
                break;
        }
    },

    // Since the only fundamental differenence between calendar based
    // and finite programs is how we place program_workouts
    // this method will abstract that change
    updateProgramItemDate(programWorkout, daysOffset) {
        switch (this.type) {
            case 1:
                // Set program year, month, day
                var programItemDate = new Date(
                    programWorkout.year,
                    programWorkout.month - 1,
                    programWorkout.day
                );
                programItemDate.setDate(programItemDate.getDate() + daysOffset);
                programWorkout.year = programItemDate.getFullYear();
                programWorkout.month = programItemDate.getMonth() + 1;
                programWorkout.day = programItemDate.getDate();
                break;
            case 2:
                // Set program timeline_day
                programWorkout.timeline_day =
                    parseInt(programWorkout.timeline_day) + daysOffset;
                break;
        }

        return programWorkout;
    },

    findDay(weekIndex, dayIndex) {
        for (let i = 0; i < this.data.weeks.length; i++) {
            if (this.data.weeks[i].index === weekIndex) {
                const weekData = this.data.weeks[i];
                const dayData = weekData.days[dayIndex];
                return dayData;
            }
        }
    },
    replaceItem(
        weekIndex,
        dayIndex,
        replaceItemId,
        newItem,
        subscribedProgram,
        subCount
    ) {
        let subscriptionTitle = '';
        let isSubscription = false;
        if (
            typeof subscribedProgram !== 'undefined' &&
            typeof subCount !== 'undefined'
        ) {
            subscriptionTitle = subscribedProgram.title;
            isSubscription = true;
        }
        for (
            let i = 0;
            i < this.weeks[weekIndex].days[dayIndex].items.length;
            i++
        ) {
            if (
                this.weeks[weekIndex].days[dayIndex].items[i].data.id ===
                replaceItemId
            ) {
                let newItem = (this.weeks[weekIndex].days[dayIndex].items[i] = {
                    type: 'workout',
                    data: newItem,
                    subscription: isSubscription,
                    subscriptionTitle,
                    subCount
                });
                this.weeks[weekIndex].days[dayIndex].items[i] = newItem;
                return newItem;
            }
        }
    },

    getTimelineDay(weekIndex, dayIndex) {
        return weekIndex * 7 + dayIndex + 1;
    },

    getWeekDayByDate(date) {
        const momentDate = moment.isMoment(date) ? date : moment(date);
        let dayFound;
        _.map(this.data.days, day => {
            const currentDate = moment(day.date).startOf('day');
            const selectedDate = moment(momentDate.toDate()).startOf('day');
            if (currentDate.isSame(selectedDate)) dayFound = day;
        });
        if (dayFound) {
            return {
                weekIndex: dayFound.weekIndex,
                dayIndex: dayFound.index
            };
        }
    },

    getDayDataByDate(date) {
        const momentDate = moment.isMoment(date) ? date : moment(date);
        const weekDayData = this.getWeekDayByDate(momentDate);
        if (!weekDayData) return null;
        return this.data.weeks[weekDayData.weekIndex].days[
            weekDayData.dayIndex
        ];
    }
};
